import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { environment } from "@env/environment";
import { GfhTransaction } from "@models/gfh-transaction.model";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class GfhTransactionService {
  constructor(private http: HttpClient) {}

  public gfhTransactions: GfhTransaction[] = [];

  get processedDate(): string {
    return this.gfhTransactions[0].processedDate;
  }

  getGroupedGfhTransactions$(id: string): Observable<any> {
    return this.http.get<Observable<any>>(
      `${environment.BASE_URL}gfhaccount/${id}/gfhtransaction?skip=0&take=5`
    );
  }
}
